import { Link } from 'react-router-dom';

export default function ProductsSection() {
  const products = [
    { title: '정밀 판금 제품', description: '레이저 가공을 통한 고정밀 판금 제품 제작' },
    { title: '용접 조립 제품', description: '전문 용접 기술로 완성된 조립 제품' },
    { title: '맞춤형 금속 부품', description: '고객 요구사항에 맞춘 맞춤 제작' },
    { title: '산업용 케이스', description: '벤딩 및 조립을 통한 산업용 케이스' },
  ];

  return (
    <section id="products" className="py-16 md:py-28 px-5 md:px-20 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-orange-500 text-xs font-semibold uppercase tracking-widest">Products</span>
          <h2 className="text-2xl md:text-5xl font-bold text-gray-900 mt-2 mb-2">제조물품</h2>
          <p className="text-sm md:text-base text-gray-500">다양한 산업 분야의 고품질 판금 제품</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10 md:mb-12" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden mb-3 h-40 md:h-60 flex items-center justify-center border border-gray-100 shadow-sm p-4 hover:shadow-md transition-shadow">
                <img
                  src="https://static.readdy.ai/image/7455c6c7e49181bdad2ed4b44e4d279c/b09fe7069d8db297eae61b8e105adfe6.png"
                  alt={product.title}
                  className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-300"
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </div>
              <h3 className="text-sm md:text-base font-semibold text-gray-900 mb-1">{product.title}</h3>
              <p className="text-xs text-gray-500 leading-snug">{product.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/gallery"
            className="inline-flex items-center gap-2 px-7 md:px-9 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-all shadow-sm hover:shadow-md whitespace-nowrap cursor-pointer text-sm"
          >
            <span>더 많은 제품 보기</span>
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}